<template>
  <ValidationObserver>
    <div class="form-group">
      <label for="booking.room">{{ $t('room') }}</label>
      <ValidationProvider name="room" vid="booking.room" rules="required" v-slot="{ errors }">
        <select class="form-control" v-model="booking.room._id" :class="{ 'is-invalid': errors[0] }">
          <option value="" disabled></option>
          <option v-for="room in rooms" v-bind:value="room._id">{{room.name}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group" v-if="selectedRoom.quantity > 1">
      <label for="booking.unit">{{ $t('unit') }}</label>
      <ValidationProvider name="unit" vid="booking.unitId" rules="required" v-slot="{ errors }">
        <select class="form-control" v-model="booking.unitId" :disabled="!booking.room" :class="{ 'is-invalid': errors[0] }">
          <option value="" disabled></option>
          <option v-for="index in selectedRoom.quantity" v-bind:value="index">
            {{ selectedRoom.units && selectedRoom.units[index - 1] ? selectedRoom.units[index - 1].name : index }}
          </option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="booking.check.in">{{ $t('checkIn') }}</label>
      <ValidationProvider name="check in" vid="booking.night.first" rules="required" v-slot="{ errors }">
        <date-picker :input-props='{
                       class: "form-control " + (errors[0] ? "is-invalid" : ""),
                       disabled: booking.referer && booking.referer.channel && booking.referer.channel != "Hostomate.com" ? "true" : false
                     }'
                     v-model="booking.check.in"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="booking.check.out">{{ $t('checkOut') }}</label>
      <ValidationProvider name="check out" vid="booking.night.last" rules="required" v-slot="{ errors }">
        <date-picker :input-props='{
                       class: "form-control " + (errors[0] ? "is-invalid" : ""),
                       disabled: booking.referer && booking.referer.channel && booking.referer.channel != "Hostomate.com" ? "true" : false
                     }'
                     v-model="booking.check.out"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
const moment = require('moment');

export default {
  name: 'Close',
  props: ['booking', 'rooms'],
  components: {
    DatePicker
  },
  computed: {
    selectedRoom: function() {
      let room = this.rooms.find(r => r._id == this.booking.room._id);
      if(room) return room;
      return {
        quantity: 0,
        units: []
      }
    }
  },
  watch: {
    'booking.room._id': function(val, oldVal) {
      console.log("wtf")
    },
    'booking.check.in': function(val, oldVal) {
      this.booking.night.first = moment(val).format('YYYY-MM-DD')
    },
    'booking.check.out': function(val, oldVal) {
      this.booking.night.last = moment(val).subtract(1, 'days').format('YYYY-MM-DD')
    }
  }
}
</script>


<i18n>
{
  "en": {
    "keypad": "Entry Code",
    "room": "Room type",
    "unit": "Unit",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "price": "Price",
    "adults": "Number of Adults",
    "children": "Number of Children"
  },
  "sl": {
    "keypad": "Številka ključavnice",
    "room": "Tip sobe",
    "unit": "Enota",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "price": "Cena",
    "adults": "Število odraslih",
    "children": "Število otrok"
  }
}
</i18n>
